module.exports = __webpack_public_path__ + "img/10.fdc2fbd.png";